/** Narrows JSON values to string when the API may send mixed shapes. */
export function asOptionalString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}
